module.exports = __webpack_public_path__ + "assets/img/index-box2-4.392c0150.png";